module.exports = __webpack_public_path__ + "img/pricetag-outline.18cfbffa.svg";